import type {RoleEnum} from 'src/api/ProactApiClient';

/**
 * Types of contextual predicates that can be used to evaluate entity-level permissions.
 * These match the backend ContextualPredicateType enum (numeric values).
 */
export enum ContextualPredicateType {
  IsCreator = 0,
  IsSupervisorOfCreator = 1,
  IsAssignee = 2,
  IsSupervisorOfAssignee = 3,
  HasRole = 4,
  SameDepartment = 5,
  InUserGroup = 6,
  Custom = 7,
}

/**
 * Defines a contextual (entity-level) permission requirement.
 * This structure matches the backend ContextualPermissionDef record.
 */
export interface ContextualPermissionDef {
  predicate: ContextualPredicateType;
  requiredRoles?: RoleEnum[];
  userGroupIds?: number[];
  customEvaluatorName?: string;
  description?: string;
}

/**
 * Interface for entities that support contextual permission evaluation.
 * Entities should provide these properties for the evaluator to work correctly.
 */
export interface ContextualEntity {
  creatorId?: number;
  creatorSupervisorId?: number;
  assigneeId?: number;
  departmentId?: number;
  // Nested creator object (alternative to flat properties)
  creator?: {
    id?: number;
    supervisorId?: number;
    departmentId?: number;
  };
}
